import { render, staticRenderFns } from "./OptimizerManagerEditTabAccount.vue?vue&type=template&id=1ec1aa73"
import script from "./OptimizerManagerEditTabAccount.vue?vue&type=script&lang=js"
export * from "./OptimizerManagerEditTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports